import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "13",
  height: "18",
  "aria-hidden": "true",
  viewBox: "0 0 13 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M7.03 17.81a.83.83 0 0 1-1.06 0L.318 13.162a.884.884 0 0 1-.13-1.223.836.836 0 0 1 1.19-.138l5.122 4.21 5.122-4.21a.83.83 0 0 1 1.19.138.89.89 0 0 1-.13 1.223zm5.65-12.974c.368.3.424.849.135 1.223a.83.83 0 0 1-1.19.134L6.5 1.984l-5.122 4.21a.83.83 0 0 1-1.19-.134.89.89 0 0 1 .13-1.223L5.97.19a.83.83 0 0 1 1.06 0z" }, null, -1)
  ])))
}
export default { render: render }